import type { NodePropertyValue } from '../../../types/properties';

const defaults: Record<string, NodePropertyValue> = {
  batchSize: 10,
  inputArray: '',
  options: {
    reset: false,
    outputFieldName: 'batches',
  },
};

export default defaults;
